import { Facebook, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0F2942] text-[#F8FAFC] pt-20 pb-10" data-testid="site-footer">
      <div className="container-pad mx-auto max-w-7xl">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_senior-support-pro/artifacts/ajhfd891_IMG_1923.jpg"
                alt="Julicare Health Services"
                className="h-12 w-12 rounded-full object-cover bg-[#F8FAFC]"
              />
              <span className="font-serif text-2xl md:text-3xl leading-tight">Julicare Health Services</span>
            </div>
            <p className="mt-5 max-w-md text-[#F8FAFC]/70 leading-relaxed">
              Compassionate in-home healthcare across the Greater Toronto Area.
              Where health meets compassion. Every shift, every visit.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <SocialLink Icon={Facebook} label="Facebook" />
              <SocialLink Icon={Instagram} label="Instagram" />
              <SocialLink Icon={Linkedin} label="LinkedIn" />
            </div>
          </div>

          <FooterCol title="Quick links">
            <a href="#about" className="hover:text-[#2A9D8F]">About</a>
            <a href="#why-us" className="hover:text-[#2A9D8F]">Why choose us</a>
            <a href="#booking" className="hover:text-[#2A9D8F]">Book a consultation</a>
            <a href="#faq" className="hover:text-[#2A9D8F]">FAQ</a>
            <a href="#contact" className="hover:text-[#2A9D8F]">Contact</a>
          </FooterCol>

          <FooterCol title="Services">
            <a href="#services" className="hover:text-[#2A9D8F]">Personal Care</a>
            <a href="#services" className="hover:text-[#2A9D8F]">Senior Home Care</a>
            <a href="#services" className="hover:text-[#2A9D8F]">Post-Surgery Care</a>
            <a href="#services" className="hover:text-[#2A9D8F]">Dementia Support</a>
            <a href="#services" className="hover:text-[#2A9D8F]">Respite Care</a>
          </FooterCol>

          <FooterCol title="Reach us">
            <span className="text-[#F8FAFC]/70">647-804-0263</span>
            <span className="text-[#F8FAFC]/70">info@julicarehealthservices.com</span>
            <span className="text-[#F8FAFC]/70">Mississauga · Milton · Oakville · Burlington · Brampton</span>
            <span className="text-[#2A9D8F]">24/7 emergency line</span>
          </FooterCol>
        </div>

        <div className="mt-14 pt-8 border-t border-[#F8FAFC]/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-[#F8FAFC]/60">
          <p>© {new Date().getFullYear()} Julicare Health Services. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[#F8FAFC]" data-testid="footer-privacy">Privacy Policy</a>
            <a href="#" className="hover:text-[#F8FAFC]" data-testid="footer-terms">Terms of Service</a>
            <a href="#" className="hover:text-[#F8FAFC]" data-testid="footer-accessibility">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}

function SocialLink({ Icon, label }) {
  return (
    <a
      href="#"
      aria-label={label}
      className="h-10 w-10 rounded-full bg-[#F8FAFC]/10 hover:bg-[#F8FAFC]/20 flex items-center justify-center transition-colors"
      data-testid={`footer-social-${label.toLowerCase()}`}
    >
      <Icon size={18} />
    </a>
  );
}

function FooterCol({ title, children }) {
  return (
    <div className="md:col-span-2">
      <p className="text-xs uppercase tracking-[0.2em] text-[#2A9D8F] font-semibold mb-4">{title}</p>
      <div className="flex flex-col gap-3 text-sm text-[#F8FAFC]/80">{children}</div>
    </div>
  );
}
